import { playSound, Sound } from '~/assets/sounds';
import { Tab } from '../Tab';
import { ITabsContainerProps, TabsContainer } from '../TabsContainer';
import { StyledMenuContainer, StyledTabButton } from './MenuTabs.styled';

interface IMenuTabsProps {
	tabs: string[];
}

const MenuTabs = ({
	tabs,
	activeIndex,
	handlePrev,
	handleNext,
	setIndex,
	...props
}: IMenuTabsProps &
	ITabsContainerProps &
	React.HTMLAttributes<HTMLDivElement>) => (
	<StyledMenuContainer {...props}>
		<StyledTabButton>Q</StyledTabButton>
		<TabsContainer
			activeIndex={activeIndex}
			handlePrev={handlePrev}
			handleNext={handleNext}
			setIndex={setIndex}
		>
			{tabs.map((item, index) => (
				<Tab key={index} onMouseEnter={() => playSound(Sound.LinkCursor)}>
					{item}
				</Tab>
			))}
		</TabsContainer>
		<StyledTabButton>E</StyledTabButton>
	</StyledMenuContainer>
);

export { MenuTabs };
